<template>
  <div id="BaseFooter" class="base-footer-component bfc">
    <div id="divFooterBand" class="row-fluid footer-band noprint" />
    <div id="divFooter" class="container noprint">
      <!-- footer help bar -->
      <div v-if="shouldShowHelpBar === true" class="row-fluid navbar-footer">
        <div class="container">
          <div class="row">
            <div class="col first" v-if="IsMcfa">
              <span class="pull-left footer-icon">
                <img
                  :src="'/Themes/Default/images/i-phone.png'"
                  width="47"
                  height="47"
                  alt="Order toll free"
                  tabindex="-1"
                />
              </span>
              <span class="left pull-left">
                <p>{{ getContentItem("orderTollFreeLabel") }}</p>
                <h4 id="supportPhoneNumber">{{ tenantDetails.SupportPhoneNumber }}</h4>
              </span>
            </div>
            <div class="col first" v-if="IsMcfe">
              <span class="pull-left footer-icon">
                <img
                  :src="'/Themes/Default/images/email.png'"
                  width="47"
                  height="47"
                  alt="Order toll free"
                  tabindex="-1"
                />
              </span>
              <span class="left pull-left">
                <p>{{ getContentItem("ForAnyInquiriesRegardingOrders") }}</p>
                <h4 id="supportPhoneNumber">{{ getContentItem("PleaseContactUsAt") }}  amcs@logisnext.eu</h4>
              </span>
            </div>
            <div v-if="IsMcfa" id="pnlSupportFooter" class="col">
              <span class="pull-left footer-icon">
                <img
                  :src="'/Themes/Default/images/i-chat.png'"
                  width="47"
                  height="47"
                  alt="Live Support"
                  tabindex="-1"
                />
              </span>
              <span class="left pull-left">
                <h4>
                  {{ getContentItem("liveSupportLabel") }}
                  <span id="pc_I_d_bottomMenu" style="cursor: pointer" />
                </h4>
              </span>
            </div>
            <div v-if="IsMcfa" id="pnlSupportFooter2" class="col">
              <span class="pull-left footer-icon">
                <img
                  :src="'/Themes/Default/images/i-searchsupport.png'"
                  width="67"
                  height="47"
                  alt="Parts Support Center"
                  tabindex="-1"
                />
              </span>
              <span class="left pull-left">
                <h4>
                  <a
                    href="https://liftnet2.mcfadealers.com/?areaname=support"
                    class="supportLink"
                    target="_blank"
                    tabindex="-1"
                    >{{ getContentItem("supportCenterLabel") }}</a
                  >
                </h4>
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- /footer help bar -->
      <div v-if="shouldShowLinks === true" id="divFooterLinks" class="row-fluid footer-links noprint">
        <!-- footer links -->
        <div tabindex="-1">
          <div v-if="IsMcfe" class="row baseFooter__links">
            <div
              v-for="(columnLinks, columnNumber) in footerColumns"
              :key="columnNumber"
              class="col-md-3 col-xs-12"
            >
              <ul class="list-group">
                <li v-for="(link, linkNumber) in columnLinks" :key="linkNumber">
                  <a
                    v-if="link.Url && typeof link.Url === 'string' && link.Url.startsWith('http')"
                    :href="link.Url"
                    target="_blank"
                    tab-index="-1"
                    class="list-group-item list-group-item-action"
                  >
                    {{ link.Name }}
                  </a>
                  <a
                    v-else-if="link.Url && typeof link.Url === 'string' && link.Url.includes('.aspx')"
                    :href="link.Url"
                    tab-index="-1"
                    class="list-group-item list-group-item-action"
                  >
                    {{ link.Name }}
                  </a>
                  <dn-router-link
                    v-else
                    :url="link.Url"
                    tab-index="-1"
                    :title="link.Name"
                    class="list-group-item list-group-item-action"
                  />
                </li>
              </ul>
            </div>
          </div>
          <div class="row">
            <div v-if="IsMcfa" class="col-10 first copyright">
              © {{ new Date().getFullYear() }} Mitsubishi Logisnext Americas Inc. CAT, CATERPILLAR, LET’S DO THE WORK,
              their respective logos, “Caterpillar Yellow”, the “Power Edge”, and Cat “Modern Hex” trade dress as well
              as corporate and product identity used herein, are trademarks of Caterpillar Inc., and may not be used
              without permission. All registered trademarks and all logos are the property of their respective owners,
              including Jungheinrich®. UniCarriers® is a registered trademark of Mitsubishi Logisnext Co., Ltd. ROCLA
              trade name, its respective wordmarks and logos as well as corporate and product identity used herein, are
              trademarks of Mitsubishi Logisnext Europe Oy, and may not be used without permission.
            </div>
            <div v-else-if="IsMcfe" class="col-10 first copyright">
              © {{ new Date().getFullYear() }}. Mitsubishi Logisnext Europe B.V. CAT, CATERPILLAR, LET’S DO THE WORK,
              their respective logos, "Caterpillar Corporate Yellow", the "Power Edge" and Cat “Modern Hex” trade dress
              as well as corporate and product identity used herein, are trademarks of Caterpillar and may not be used
              without permission. All registered trademarks, logos and product identity used herein are the property of
              their respective owners and may not be used without permission.
            </div>
            <div v-else class="col-10 first copyright">
              Copyright © {{ new Date().getFullYear() }}. All rights reserved. CAT, CATERPILLAR, their respective logos,
              "Caterpillar Yellow," the "Power Edge" trade dress as well as corporate and product identity used herein,
              are trademarks of Caterpillar and may not be used without permission. All registered trademarks are the
              property of their respective owner
            </div>
            <div id="divSocialMedia" class="col-2 copyright">
              <a href="https://www.linkedin.com/company/mitsubishi-logisnext-americas/" target="_blank" tabindex="-1"
                ><img
                  :src="'/Themes/Default/images/linkedin-icon.ico'"
                  title="LinkedIn"
                  alt="LinkedIn"
                  class="bfc__linkedin-icon" /></a
              >&nbsp;&nbsp;
              <a href="https://www.youtube.com/c/MitsubishiLogisnextAmericasInc" target="_blank" tabindex="-1"
                ><img
                  :src="'/Themes/Default/images/youtube-icon.png'"
                  title="Youtube"
                  alt="Youtube"
                  class="bfc__youtube-icon"
              /></a>
            </div>
            <div v-if="showPrivacyFooter" class="bfc__privacy-div">
              <div class="bfc__privacy-div-links">
                <a class="bfc__privacy-div-links" :href="termsAndConditionsLink"
                  >{{ getContentItem("TermsAndConditions") }} |
                </a>
                <a class="bfc__privacy-div-links" :href="privacyLink">{{ getContentItem("PrivacyPolicy") }} | </a>
                <a class="bfc__privacy-div-links" :href="cookieLink">{{ getContentItem("CookiePolicy") }}</a>
              </div>
              <div class="bfc__copyright">
                {{ getContentItem("CopyrightMessage") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { DnRouterLink } from "@/components/Elements";
import { constants }    from "@/const";
import { FeatureFlagService } from "@/services/FeatureFlagService";
import { UserService } from "@/services/UserService";

export default {
  components: {
    DnRouterLink,
  },
  props: {
    shouldShowHelpBar: {
      type: Boolean,
      default: true,
    },
    shouldShowLinks: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters(["getContentItem", "IsMcfa", "tenantDetails", "IsMcfe", "IsMcfs", "user"]),
    privacyLink() {
      return this.getContentItem(window.appGlobals.GLOBAL_LOGIN_PRIVACY_POLICY_KEY);
    },
    cookieLink() {
      return this.getContentItem(window.appGlobals.GLOBAL_LOGIN_COOKIE_POLICY_KEY);
    },
    termsAndConditionsLink() {
      return this.getContentItem(window.appGlobals.GLOBAL_LOGIN_TERMS_AND_CONDITIONS_KEY);
    },
    showPrivacyFooter(){
      return FeatureFlagService.getFeatureEnabled(constants.FEATURE_NAMES.SHOW_PRIVACY_FOOTER)
    }
    ,
    // Merge tenant footer links with dynamic support sites
    footerColumns() {
      const tenantFooterColumns = (this.tenantDetails && Array.isArray(this.tenantDetails.FooterLinks)) ? this.tenantDetails.FooterLinks.slice() : [];
      if (!this.IsMcfe || !this.supportSites || this.supportSites.length === 0) {
        return tenantFooterColumns;
      }

      const supportLinks = this.supportSites.slice();
      const footerColumnsMerged = tenantFooterColumns.map((col, idx) => {
        if (idx < supportLinks.length) {
          return col.concat(supportLinks[idx]); // Add one support link per column
        }
        return col;
      });

      // If there are remaining support links, add them to the last column
      if (supportLinks.length > tenantFooterColumns.length) {
        footerColumnsMerged[footerColumnsMerged.length - 1] = footerColumnsMerged[footerColumnsMerged.length - 1].concat(supportLinks.slice(tenantFooterColumns.length));
      }

      return footerColumnsMerged;
    }
  },

  data() {
    return {
      supportSites: []
    }
  },

  created() {
    // Only load for MCFE tenants and when user is available
    if (!this.IsMcfe) return;

    if (this.user && this.user.UserId) {
      this.loadSupportSites();
    } else {
      const unwatch = this.$watch('user.UserId', (val) => {
        if (val) {
          this.loadSupportSites();
          unwatch();
        }
      })
    }
  },

  methods: {
    loadSupportSites() {
      if(!this.IsMcfe){
        return;
      }
      try {
        const dealerCode = this.user && this.user.DealerCode;
        const userId = this.user && this.user.UserId;
        const dealerRange = this.user && this.user.DealerRange;
        if (!dealerCode || !userId) return;
        UserService.GetMCFEDealerSupportSites(dealerCode, userId, dealerRange)
          .then(r => {
            this.supportSites = Array.isArray(r.data) ? r.data : [];
          })
          .catch(err => {
            console.error('Failed to load support sites', err);
          });
      } catch (ex) {
        console.error('Error in loadSupportSites', ex);
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.baseFooter__links,
.navbar-footer {
  padding-left: 7%;
}
.bfc__linkedin-icon {
  height: 32px;
  width: 32px;
}
.bfc__youtube-icon {
  border-radius: 4px;
  height: 30px;
  width: 30px;
}
.bfc__privacy-div {
  width: 100%;
  height: 7vh;
  background-color: $brand;
  align-content: center;
  text-align: center;
  margin-bottom: 5px;
}
.bfc__privacy-div-links {
  color: white;
}
.bfc__copyright {
  margin-top: 5px;
  color: white;
}
</style>